import React, { useContext, useState } from 'react';
import moment from 'moment';
import SignaturePad from 'react-signature-canvas';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tooltip, InputLabel, Grid, TableCell, TableRow, Paper, FormHelperText, Typography, CircularProgress, IconButton, Hidden } from '@material-ui/core';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import {
    SecondaryButton,
    InputText,
    FailButton,
    PassButton,
    NAButton,
    MButton,
    RButton,
    BackButton,
    DatePicker,
    SelectBox,
    formatters,
    SimpleField,
    DefaultButton,
    Accordion
} from '../../../../../Core/Controls';
import DeleteIcon from '@material-ui/icons/Delete';
import EditAxle from './EditInspectionCheck/editAxel';
import '../../controllerStyle.scss';
import ActionTakenModal from './EditInspectionCheck/actionTakenModal';
import DialogComp from '../../../../../Core/Dialog/DialogComp';
import ConfirmationModal from '../../../../../Core/Modal/ConfirmationModal';
import ImageModal from '../DriverDailyChecks/imageModal';
import { EditInapectionContaxt, EditInspectionProvide } from './EditInspectionCheck/editInspectionProviderImports';
import { EditInspectionBreakTest } from './EditInspectionCheck/editInspectionbreakTest';
import { EditInspectionBrakePerformance } from './EditInspectionCheck/editInspectionBP';
import { EditInspectionRoadTest } from './EditInspectionCheck/editInspaectionRoadTest';
import { EditInspection } from './EditInspectionCheck/editInspection';
import { EditSInspectionSignOFF } from './EditInspectionCheck/editSignOff';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import ImageUpload from './InspectionImageUpload';
import ReturnToEngineer from './returnToEngineer';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { getGenerateVehicleInspectionReportPdf } from '../../../../../Core/Services/InternalUser/Vehicle/vehicleTabChecks';
import { useToast } from '../../../../../Core/Hooks/useToast';
import { useHistory } from 'react-router-dom';
import AllStickyNotes from '../../Notes/stickyAllNotes';
import InspectionNotes from './InspectionNotes';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 16,
        padding: '8px 20px',
        color: '#f50057'
    },
    body: {
        fontSize: 14,
        padding: '8px 20px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 15
    },
    table: {
        minWidth: '100%'
    },

    title: {
        color: '#f50057',
        marginLeft: 8,
        marginTop: 8,
        marginBottom: 8
    },
    loader: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
        // marginTop: 100
    },
    paper: {
        padding: theme.spacing(2),
        // color: theme.palette.text.secondary,
        border: '1px solid rgba(0,0,0,0.2)',
        width: '100%'
    },
    axelTitles: {
        textAlign: 'center',
        color: '#f50057',
        width: '100%'
    },
    headings: {
        color: '#f50057',
        margin: 0,
        marginLeft: -4,
        marginBottom: 20
    },
    modalHeight: {
        height: `calc(100vh - 108px)`, // Default height calculation
        overflowY: 'auto', // Enable vertical scrolling
        '@media (min-width: 821px) and (max-width: 1024px)': {
            // height: `calc(100vh - 650px)` // Adjust height for devices between 821px and 1024px
            height: `100%`
        },
        '@media (min-width: 770px) and (max-width: 820px)': {
            // height: `calc(100vh - 450px)` // Adjust height for devices between 770px and 820px
            height: `100%`
        },
        '@media (min-width: 768px) and (max-width: 769px)': {
            // height: `calc(100vh - 280px)` // Adjust height for devices between 768px and 769px
            height: `100%`
        },
        '@media (min-width: 712px) and (max-width: 767px)': {
            // height: `calc(100vh - 400px)` // Adjust height for devices between 712px and 767px
            height: `100%`
        }
    }
}));

const CheckButtons = {
    S: PassButton,
    D: FailButton,
    M: MButton,
    N: NAButton,
    R: RButton
};

const CheckButtonsBorder = {
    D: 'red',
    M: 'orange',
    N: 'blue',
    S: 'green',
    R: 'red'
};

const IconColors = {
    fontSize: 15,
    color: 'white'
};
const fontColors = {
    fontSize: 12,
    color: 'white'
};

const ButtonColors = {
    D: { color: '#d32f2f', value: () => <ClearIcon style={IconColors} /> },
    M: { color: '#f57f17', value: () => <span style={fontColors}>M</span> },
    N: { color: '#3f51b5', value: () => <span style={fontColors}>N/A</span> },
    S: { color: '#388e3c', value: () => <DoneIcon style={IconColors} /> }
};

const EditVehicleDailyChecks = (props) => {
    const classes = useStyles();
    const {
        checkhaveAccess,
        widths,
        portalSettings,
        btnLoader,
        confirmBtnLoader,
        state,
        flags,
        isModal,
        handleInput,
        // clear,
        // GetTechnicianSign,
        onImageChange,
        // useDefaultSig,
        submitData,
        closeActionTakenhandle,
        closeReturnToEngModal,
        showReturnToEngModal,
        confirmHandle,
        sumbitImage,
        setState,
        // signCanvas,
        imgLoader,
        RemoveImage,
        closeInspection,
        PrevID,
        localFileInputRef,
        submitSignOffDInsp
    } = useContext(EditInapectionContaxt);
    const { showToastSuccess, showToastError } = useToast();
    const history = useHistory();
    const [pdfLoading, setPdfLoading] = useState(false);
    const GlobalCss = withStyles((theme) => ({
        '@global': {
            '.MuiDialogContent-root': {
                padding: '10px',
                [theme.breakpoints.down('sm')]: {
                    padding: '0px' // Customize the padding for 'sm' and up screens
                }
            }
        }
    }))(() => null);
    const GenerateVehicleInspectionReportPdf = async () => {
        try {
            setPdfLoading(true);
            let res = await getGenerateVehicleInspectionReportPdf(props.checkID, props.displayCheck);

            if (res.success) {
                showToastSuccess('Invoice PDF Generated Successfully');
                history.goBack();
            } else {
                showToastError(res.message);
            }
        } catch (err) {
            showToastError(err?.message || 'Failed to generate PDF');
        } finally {
            setPdfLoading(false);
        }
    };

    // const ScrollPage = () => {
    const goToStart = () => {
        document.getElementById('pageStart')?.scrollIntoView({
            behavior: 'smooth'
        });
    };

    const goToEnd = () => {
        document.getElementById('pageEnd')?.scrollIntoView({
            behavior: 'smooth'
        });
    };

    let InspectorDeclaration = portalSettings.portalSettingTechnicianDeclaration?.replace('{eventname}', flags.scheduleEventName);

    const Header = () => {
        return (
            <Grid container justify="space-between" spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant={'h5'} style={{ fontSize: widths < 500 ? 17 : '', display: 'flex', alignItems: 'center' }}>
                            {/* <BackButton onClick={PrevID ? closeInspection : props.onClose} /> */}
                            {widths < 1024 ? state.regNumber : state.vehicleInfo?.toUpperCase() || ''} - {flags.scheduleEventName || ''}
                        </Typography>
                        <IconButton onClick={PrevID ? closeInspection : props.onClose} aria-label="close" style={{ padding: 6 }}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </Grid>

                <Grid item container xs={12} spacing={2} alignItems="center" justify="space-between">
                    <Grid item md={6} lg={8} xl={8}>
                        <Grid container alignItems="center" spacing={2}>
                            <Hidden only={['md', 'lg', 'xl']}>
                                {state.buttonList?.map((k) => {
                                    const Icon = ButtonColors[k.inspectionSheetCheckOptionCode].value;

                                    return (
                                        <Grid item xs={4} sm={4} md={4} key={k.inspectionSheetCheckOptionCode}>
                                            <IconButton
                                                style={{
                                                    background: ButtonColors[k.inspectionSheetCheckOptionCode].color,
                                                    borderRadius: 0,
                                                    height: 30,
                                                    width: '100%',
                                                    padding: 10,
                                                    fontSize: 8,
                                                    color: 'white'
                                                }}
                                            >
                                                {' '}
                                                <div
                                                    style={{
                                                        padding: 8,
                                                        fontSize: 8,
                                                        fontWeight: 600,
                                                        color: 'white'
                                                    }}
                                                >
                                                    {k.inspectionSheetCheckOptionDescription}
                                                </div>
                                            </IconButton>
                                        </Grid>
                                    );
                                })}
                            </Hidden>
                            <Hidden only={['sm', 'xs']}>
                                {state.buttonList?.map((k) => {
                                    const Icon = ButtonColors[k.inspectionSheetCheckOptionCode].value;

                                    return (
                                        <Grid item key={k.inspectionSheetCheckOptionCode}>
                                            <IconButton
                                                style={{
                                                    background: ButtonColors[k.inspectionSheetCheckOptionCode].color,
                                                    borderRadius: 0,
                                                    height: 20,
                                                    // width: '100%',
                                                    padding: 10,
                                                    fontSize: 12,
                                                    color: 'white'
                                                }}
                                            >
                                                <Icon style={{ fontSize: 12 }} /> {/* Render the icon component here */}
                                                <div
                                                    style={{
                                                        padding: 8,
                                                        fontSize: 10,
                                                        fontWeight: 600,
                                                        color: 'white'
                                                    }}
                                                >
                                                    {k.inspectionSheetCheckOptionDescription}
                                                </div>
                                            </IconButton>
                                        </Grid>
                                    );
                                })}
                            </Hidden>
                            {/* {state.buttonList?.map((k) => {
                                            const Icon = ButtonColors[k.inspectionSheetCheckOptionCode].value;

                                            return (
                                                <Grid item key={k.inspectionSheetCheckOptionCode}>
                                                    <IconButton
                                                        style={{
                                                            background: ButtonColors[k.inspectionSheetCheckOptionCode].color,
                                                            borderRadius: 0,
                                                            height: 20,
                                                            width: '100%',
                                                            padding: 10,
                                                            fontSize: 12,
                                                            color: 'white'
                                                        }}
                                                    >
                                                       
                                                        <div
                                                            style={{
                                                                padding: 8,
                                                                fontSize: 13,
                                                                fontWeight: 600,
                                                                color: 'white'
                                                            }}
                                                        >
                                                            {k.inspectionSheetCheckOptionDescription}
                                                        </div>
                                                    </IconButton>
                                                </Grid>
                                            );
                                        })} */}
                        </Grid>
                    </Grid>
                    {flags.generateDocument && (
                        <Grid item md={5} lg={3} xl={3}>
                            <SecondaryButton
                                onClick={GenerateVehicleInspectionReportPdf}
                                isBtnLoader={pdfLoading}
                                disabled={pdfLoading}
                                forceEnabled={true}
                                icon={PictureAsPdfIcon}
                            >
                                Generate PDF
                            </SecondaryButton>
                        </Grid>
                    )}
                </Grid>

                <Hidden only={['sm', 'xs']}>
                    <Grid item xs={12} sm={4} md lg={1} xl>
                        <div className="input-style">
                            <InputLabel shrink className="input_label">
                                Calibration Date
                            </InputLabel>
                            <div className="input_value_Inspection">{formatters.DateOnlyFormatter(state.vehicleNextCalibrationDate) || 'N/A'}</div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={4} md lg={2} xl>
                        <div className="input-style">
                            <InputLabel shrink className="input_label">
                                Tacho Calibration Date
                            </InputLabel>
                            <div className="input_value_Inspection">{formatters.DateOnlyFormatter(state.vehicleNextTachoCalibrationDate) || 'N/A'}</div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={4} md lg={1} xl>
                        <div className="input-style">
                            <InputLabel shrink className="input_label">
                                Date Of Check
                            </InputLabel>
                            <div className="input_value_Inspection">{state.date || 'N/A'}</div>
                        </div>
                    </Grid>

                    {flags.displayMileage && (
                        <Grid item xs={12} sm={4} md lg={2} xl>
                            <InputLabel shrink className="input_label">
                                Odometer Reading (KM)
                            </InputLabel>
                            <div className="input_value_Inspection">{state.vehicleDailyCheckMileage}</div>
                        </Grid>
                    )}
                    <Grid item xs={12} sm={12} md lg={2} xl>
                        <InputLabel shrink className="input_label">
                            Check carried out by
                        </InputLabel>
                        <div className="input_value_Inspection">{state.vehicleDailyCheckCheckerName}</div>
                    </Grid>
                </Hidden>
                <Hidden only={['md', 'lg', 'xl']}>
                    <Grid item xs={12}>
                        <Accordion header="Inspection Details" defaultExpanded>
                            <Grid Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={6}>
                                    <div className="input-style">
                                        <InputLabel shrink className="input_label">
                                            Calibration Date
                                        </InputLabel>
                                        <div className="input_value_Inspection">{formatters.DateOnlyFormatter(state.vehicleNextCalibrationDate) || 'N/A'}</div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div className="input-style">
                                        <InputLabel shrink className="input_label">
                                            Tacho Calibration Date
                                        </InputLabel>
                                        <div className="input_value_Inspection">
                                            {formatters.DateOnlyFormatter(state.vehicleNextTachoCalibrationDate) || 'N/A'}
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div className="input-style">
                                        <InputLabel shrink className="input_label">
                                            Date Of Check
                                        </InputLabel>
                                        <div className="input_value_Inspection">{state.date || 'N/A'}</div>
                                    </div>
                                </Grid>

                                {flags.displayMileage && (
                                    <Grid item xs={12} sm={6}>
                                        <InputLabel shrink className="input_label">
                                            Odometer Reading (KM)
                                        </InputLabel>
                                        <div className="input_value_Inspection">{state.vehicleDailyCheckMileage}</div>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={12}>
                                    <InputLabel shrink className="input_label">
                                        Check carried out by
                                    </InputLabel>
                                    <div className="input_value_Inspection">{state.vehicleDailyCheckCheckerName}</div>
                                </Grid>
                            </Grid>
                        </Accordion>
                    </Grid>
                </Hidden>

                <Grid item xs={12} sm={12} md={12} lg={4} className="mandatory-fields">
                    <InputLabel shrink>Slippage Reason</InputLabel>
                    <SelectBox
                        List={state.slippageReasons}
                        name="vehicleInspectionSlippageReasonID"
                        onChange={handleInput}
                        value={state.vehicleInspectionSlippageReasonID}
                    />
                </Grid>
            </Grid>
        );
    };

    const showReturnToEngBtn = state.vehicleInspectionStatusID === 3 || state.vehicleInspectionStatusID === 2 || state.vehicleInspectionStatusID === 1;

    const showSignOffBtn =
        !state.isSignOff &&
        state.vehicleInspectionStatusID !== 2 &&
        !state.hideSignOff &&
        (flags.scheduleEventIs2ndSignOffRequired || state.vehicleInspectionStatusID !== 4);

    const allOtherButtonsHidden = !showReturnToEngBtn && !showSignOffBtn;

    return (
        <>
            <GlobalCss />
            <DialogComp hideCloseAction={true} onClose={PrevID ? closeInspection : props.onClose} title={<Header />} maxWidth="xl" fullWidth fullScreen>
                <div style={{ overflow: 'auto', padding: 10 }} className={classes.modalHeight}>
                    {!state.load ? (
                        <Grid container spacing={2} justify="space-between">
                            {!state.hideSignOff && (
                                <Grid item xs={12} pageStart>
                                    <InspectionNotes list={state.inpsectionNotes} />
                                </Grid>
                            )}
                            {/* Inspections */}
                            <EditInspection classes={classes} StyledTableCell={StyledTableCell} StyledTableRow={StyledTableRow} CheckButtons={CheckButtons} />
                            {/* Tyre checks column */}
                            {flags.displayTyres && (
                                <Grid item container direction="row" xs={12} sm={12}>
                                    <EditAxle state={state} classes={classes} vehicleNoOfAxles={state.vehicleNoOfAxles} />
                                </Grid>
                            )}
                            {flags.displayBrakeTest && <EditInspectionBreakTest classes={classes} />}
                            {flags.displayBrakePerformance && <EditInspectionBrakePerformance classes={classes} />}
                            {flags.displayRoadTest && <EditInspectionRoadTest classes={classes} />}
                            {/* Vehicle SignOff page */}
                            <Grid item container xs={12}>
                                <Paper className={classes.paper}>
                                    <Grid container xs={12}>
                                        <h3 className={classes.headings}>Vehicle Inspector</h3>
                                    </Grid>
                                    <Grid container xs={12}>
                                        <div
                                            className={classes.headings}
                                            style={{ marginTop: -20 }}
                                            dangerouslySetInnerHTML={{ __html: InspectorDeclaration }}
                                        />
                                    </Grid>
                                    <Grid container spacing={1} justify="space-between">
                                        <Grid item container spacing={1} xs={12} md={6}>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <InputLabel shrink>Vehicle Checker Comment</InputLabel>
                                                <Typography variant="button">{state.vehicleInspectionInspectionComment}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item spacing={1} xs={12} md={6}>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <div style={{ position: 'relative' }}>
                                                    <InputLabel shrink>Signature</InputLabel>
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            right: 0
                                                        }}
                                                    ></div>
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            right: 5,
                                                            bottom: 0,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'flex-end'
                                                        }}
                                                    >
                                                        <Typography variant="body1">{state.vehicleDailyCheckCheckerName}</Typography>
                                                        <Typography variant="button">
                                                            {moment(state.vehicleInspectionDateInspected).format('DD/MM/YYYY')}
                                                        </Typography>
                                                    </div>

                                                    {state.imgtechniciansign ? (
                                                        <div className="sigContainer">
                                                            <img src={state.imgtechniciansign} style={{ width: '100%', height: '100%' }} alt="my signature" />
                                                        </div>
                                                    ) : (
                                                        <div className="sigContainer">
                                                            <Typography variant="button">No Signature Found</Typography>
                                                        </div>
                                                    )}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container xs={12}>
                                        <h5 className={classes.headings} style={{ height: 20 }}>
                                            &nbsp;
                                        </h5>
                                    </Grid>
                                </Paper>
                            </Grid>
                            {(checkhaveAccess?.CanUpdateVehicleInspections ||
                                flags.displayCustomerDeclaration === 1 ||
                                flags.displayCustomerDeclaration === 2) &&
                                (flags.scheduleEventIs2ndSignOffRequired || state.signOffsignature) && <EditSInspectionSignOFF classes={classes} />}
                            <Grid item container spacing={2} xs={12} lg={12}>
                                {showReturnToEngBtn && (
                                    <Grid item xs={12} sm={6} md={showSignOffBtn ? 4 : 6} lg={showSignOffBtn ? 4 : 6} xl={showSignOffBtn ? 4 : 6}>
                                        <SecondaryButton onClick={showReturnToEngModal}>Return To Engineer</SecondaryButton>
                                    </Grid>
                                )}
                                {showSignOffBtn && (
                                    <Grid item xs={12} sm={6} md={showReturnToEngBtn ? 4 : 6} lg={showReturnToEngBtn ? 4 : 6} xl={showReturnToEngBtn ? 4 : 6}>
                                        <DefaultButton
                                            isBtnLoader={btnLoader}
                                            onClick={confirmHandle}
                                            // color="success"
                                            style={{ background: '#4caf50', color: 'white' }}
                                            disabled={
                                                !checkhaveAccess?.CanUpdateVehicleInspections &&
                                                flags.displayCustomerDeclaration !== 1 &&
                                                flags.displayCustomerDeclaration !== 2
                                            }
                                        >
                                            Sign Off
                                        </DefaultButton>
                                    </Grid>
                                )}

                                {!PrevID && (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={allOtherButtonsHidden ? 12 : 6}
                                        md={allOtherButtonsHidden ? 12 : showReturnToEngBtn && showSignOffBtn ? 4 : 6}
                                        lg={allOtherButtonsHidden ? 12 : showReturnToEngBtn && showSignOffBtn ? 4 : 6}
                                        xl={allOtherButtonsHidden ? 12 : showReturnToEngBtn && showSignOffBtn ? 4 : 6}
                                    >
                                        <SecondaryButton onClick={() => props.onClose()}>Cancel</SecondaryButton>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <div style={{ height: 160 }} id="pageEnd">
                                        &nbsp;
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : (
                        <div className={classes.loader}>
                            <CircularProgress color="secondary" />
                        </div>
                    )}
                    {/* Checks Table */}

                    {isModal.actionTaken ? (
                        <DialogComp title="Defect Action" onClose={() => closeActionTakenhandle(false)} maxWidth="md" overflow="auto" fullWidth>
                            <ActionTakenModal selectedCheck={isModal.selectedCheck} onClose={closeActionTakenhandle} />
                        </DialogComp>
                    ) : null}

                    {isModal.showConfirm ? (
                        <DialogComp
                            title={`Confirm ${state.isCustomerSignOff ? 'Customer' : ''} Sign Off`}
                            onClose={() => closeActionTakenhandle(false)}
                            maxWidth="sm"
                        >
                            <ConfirmationModal
                                message={`Please note that you will not be able to make any changes once submitted. Click the Confirm button to proceed or Cancel to abort.`}
                                handleSubmit={submitSignOffDInsp}
                                handleCancel={() => closeActionTakenhandle(false)}
                                title={`Confirm ${state.isCustomerSignOff ? 'Customer' : ''} Sign Off`}
                                isBtnLoader={confirmBtnLoader}
                            />
                        </DialogComp>
                    ) : null}
                    <ImageUpload
                        disabled={state.isDisabled}
                        state={state}
                        isAPI={state.fromApi}
                        onImageChange={onImageChange}
                        RemoveImage={RemoveImage}
                        submitImage={sumbitImage}
                        onClose={() => setState((st) => ({ ...st, showImageModal: false }))}
                        maxNumber={10}
                        loader={false}
                        showDialog={!!state.showImageModal}
                        fileInputRef={localFileInputRef}
                    />
                    {isModal.returnToEngModalShow ? (
                        <DialogComp title="Return To Engineer" onClose={() => closeReturnToEngModal(false)} maxWidth="md" overflow="auto" fullWidth>
                            <ReturnToEngineer onClose={closeReturnToEngModal} vehicleInspectionID={state.vehicleInspectionID} />
                        </DialogComp>
                    ) : null}

                    {/* {state.openDefectInspection ? (
                        <DialogComp title={state.inspectionName || 'Defect Inspection'} onClose={closeInspection} maxWidth="md" overflow="auto" fullWidth>
                           
                            <EditVehicleDailyChecks checkID={PrevID} displayCheck={props.displayCheck} onClose={closeInspection} frompage={false} />
                        </DialogComp>
                    ) : null} */}

                    <div style={{ position: 'fixed', right: '20px', bottom: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <button onClick={goToStart} title="Scroll Top">
                            <ExpandLessIcon />
                        </button>
                        <button onClick={goToEnd} title="Scroll Bottom">
                            <ExpandMoreIcon />
                        </button>
                    </div>
                </div>
            </DialogComp>
        </>
    );
};

const Screen = (props) => {
    return (
        <EditInspectionProvide {...props}>
            <EditVehicleDailyChecks {...props} />
        </EditInspectionProvide>
    );
};
export default Screen;
